import React, {Component} from 'react';
import "./style.css"

class Carousel extends Component {

    state = {
        activeIndex: 0
    }

    componentDidMount() {

        this.timer = setInterval(() => {

            let index = this.state.activeIndex
            if (this.state.activeIndex + 1 >= this.props.children.length) {
                index = 0
            } else {
                index++
            }

            this.setState({activeIndex: index}, this.afterChange)

        }, this.props.delay ? this.props.delay : 4000)

    }

    componentWillUnmount() {
        clearInterval(this.timer)
    }

    afterChange = () => {

        if (this.props.afterChange) {
            this.props.afterChange(this.state.activeIndex)
        }

    }

    dots = () => {

        if (this.props.dots === false) {
            return
        }

        let arr = []
        for (let i = 0; i < this.props.children.length; i++) {
            arr.push(<span className={this.state.activeIndex === i ? 'active' : ''} key={i} onClick={() => {
                this.setState({activeIndex: i}, this.afterChange)
            }}></span>)
        }

        return arr
    }


    render() {
        return (
            <div className="Carousel">

                {this.props.children.map((item, index) => {
                    return this.state.activeIndex === index ? item : ''
                })}

                <div className="dots">
                    {this.dots()}
                </div>
            </div>
        )
    }
}

export default Carousel